import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { PresetColors } from "../../../../common/constants";
import { ClientType } from "../../enums";

interface Props {
  type?: ClientType;
  closable?: boolean;
  style?: React.CSSProperties;
  onClose?: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  label?: React.ReactNode;
}

export const ClientTypeTag = ({ type, closable, style, onClose, label }: Props) => {
  const { t } = useTranslation();

  let color;

  switch (type) {
    case ClientType.NATURAL:
      color = PresetColors.BLUE;
      break;
    case ClientType.SELF_EMPLOYED:
      color = PresetColors.GOLD;
      break;
    case ClientType.LEGAL:
      color = PresetColors.PURPLE;
      break;
  }

  return type || label ? (
    <Tag color={color} closable={closable} style={{ minWidth: 40, textAlign: "center", ...style }} onClose={onClose}>
      {type ? t("client.enums.type." + type) : label}
    </Tag>
  ) : null;
};
